import React from 'react';
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { useTranslation } from 'react-i18next';
import {navigateTo} from "../../Helper"

const ListCard = ({ title, items }) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { t } = useTranslation();

    const handleClick = (subcategory) => {
        navigateTo(dispatch, navigate, `/providers/${subcategory}`);
    }; 

    return <div className='mt20 list-card'>
        <div className='list-card-header'>
            <div className='text-align-center font-30 font-bold color-white'>{t(title)}</div>
        </div>
        <div className='list-card-body'>
            {items.map(item => (
                <div key={item.name} className='text-align-center font-25 font-bold color-550952 pointer' onClick={() => handleClick(item.subcategory ?? item.name)}>{t(item.name)}</div>
            ))}
        </div>
    </div>;
};

export default ListCard;